import { css } from "@emotion/css";

import { grey, yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createLevelsListStyles = ({
  spacing,
  borderRadius,
  typography,
}: Theme) => {
  return {
    root: css({
      display: "grid",
      marginTop: spacing(3),
      gap: spacing([2.5, 5]),
      gridTemplateColumns: "1fr 1fr",
    }),
    level: css({
      display: "flex",
      justifyContent: "flex-start",
      "&:nth-child(odd)": {
        marginTop: spacing(-7),
        justifyContent: "flex-end",
      },
      "&:nth-child(1)": {
        marginTop: spacing(0),
      },
      "&:nth-child(2)": {
        marginTop: spacing(7),
      },
    }),
    levelIcon: css({
      marginBottom: spacing(2),
    }),
    requirements: css({
      marginTop: spacing(1),
    }),
    requirement: css({
      display: "flex",
      alignItems: "center",
      color: grey[900],
      marginBottom: spacing(1),
      fontWeight: typography.fontWeight.normal,
    }),
    statusIcon: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: grey[200],
      marginRight: spacing(1),
      width: 15,
      height: 15,
      borderRadius: borderRadius.round,
    }),
    done: css({
      backgroundColor: yellow[200],
    }),
  };
};
